import React from 'react';

/**
 * A constrained measure at body size, for running prose.
 *
 * Vertical rhythm runs one way only: margin-top on following siblings, so
 * a block never has to know what comes before it.
 */
export function Prose({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div data-component-id="C36" className={`max-w-prose leading-relaxed text-ink/80 [&>*+*]:mt-4 ${className}`} data-id="element-463" data-mp="29b1o11hepvj7">
      {children}
    </div>;
}